import { render } from "./PaymentAdjustmentsHistory.vue?vue&type=template&id=bd075dd0&scoped=true"
import script from "./PaymentAdjustmentsHistory.vue?vue&type=script&lang=js"
export * from "./PaymentAdjustmentsHistory.vue?vue&type=script&lang=js"

import "./PaymentAdjustmentsHistory.vue?vue&type=style&index=0&id=bd075dd0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd075dd0"]])

export default __exports__